import { TipCardExtraStyles } from './TipCard.types'

export const extraStylesDefault: TipCardExtraStyles = {
  containerMain: {},
  containerTitle: {},
  containerContent: {},
}
